<template>
  <div class="cookie__button">
    <button
      class="cookie__button-label apollo__link"
      tabindex="0"
      role="button"
      aria-pressed="true"
      @click="accept"
    >
      <bdi>{{ label }}</bdi>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CookieButton',

  props: {
    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    accept() {
      localStorage.setItem('cookie:accepted', '1');
      this.$parent.$emit('cookie-accepted');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie__button {
  // display: inline;

  display: block;
  @include mq(ipadP) {
  }
}
.cookie__button button {
  position: relative;
  cursor: pointer;
  outline: transparent;

  @at-root [data-theme="default"] & {
    margin-top: 15px;
    background-color: transparent;
    text-align: center;
    border: none;
    -webkit-appearance: none;
    appearance: none;
    font-weight: 400;
    padding: 0px;
    font-size: 16px;
    color: $color-black;
    font-weight: 400;
    font-style: normal;
    font-family: $font-family-base;

    @include mq($and: $is-touch-device) {
      color: $color-black;
    }

    @include mq(ipadP) {
      margin-top: 0px;
      padding: 30px 40px 30px 40px;

      &::after {
        content: '';
        position: absolute;
        width: 1px;
        left: 0;
        top: 0;
        height: 100%;

        background: #d8d8d8;
        transition: all 0.3s ease-out;
      }

      &:hover {
        color: $color-black;

        &::after {
          background: darken(#d8d8d8, 2.5%);
          transform: translateY(-40px);
          height: calc(100% + 80px);
        }
      }
    }

    transition: color 0.4s ease-out;
  }
}
</style>
